import { render, staticRenderFns } from "./GiftCardManagerShow.vue?vue&type=template&id=1090aae3&"
import script from "./GiftCardManagerShow.vue?vue&type=script&lang=js&"
export * from "./GiftCardManagerShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports